import React from 'react';
import '../CSS/UnderMaintenance.css';
import logo from '../Images/LogoStroke.png';

const Maintenance = () => {
  return (
    <div className='bigDiv'>
        <div className="er-maintenanceCard">
            <div className='logoContainer'>
                <img src={logo} className='logo' alt=""/>
            </div>

            <h1 className='bigTitle1'>ESTAMOS QUASE PRONTOS...</h1>
            <p className='smallTitle1'>Fiquem atentos, novidades em breve!</p>

            <div className="er-maintenanceDivider" />

            <h1 className='bigTitle1'>WE ARE ALMOST READY...</h1>
            <p className='smallTitle1'>Stay tuned, news coming soon!</p>
        </div>
    </div>
  );
};

export default Maintenance;